
import { ColumnFilter } from './ColumnFilter';
// Define statusColors (reuse from FichaPresupuesto or define here)
const statusColors = {
  CREADO: 'black',
  ENVIADO: 'blue',
  'EN NEGOCIACIÓN': 'orange',
  'SIN RESPUESTA': 'gray',
  APROBADO: 'green',
  RECHAZADO: 'red'
};
export const COLUMNS = [
	{
		Header : 'id ',
		Footer : 'id',
		accessor: 'idpresupuestos',
		Filter: ColumnFilter,
		//disableFilters: true,
	},
	{
		Header : 'nombre',
		Footer : 'nombre',
		accessor: 'nombre_cliente',
		Filter: ColumnFilter,
	},
	{
		Header : 'Telefono',
		
		accessor: 'telefono_cliente',
		Filter: ColumnFilter,
	},
	{
		Header : 'Monto',
		accessor: 'monto_total',
		Filter: ColumnFilter,
	},
	
{
  Header: 'Estado',
  accessor: 'estado',
  Filter: ColumnFilter,
  Cell: ({ value }) => (
    <span style={{ color: statusColors[value] || 'black' }}>
      {value}
    </span>
  ),
},
	
	
]
